/**
 * Client-side LaunchDarkly initialization tuning.
 *
 * `LDProvider` forwards its `timeout` prop to the JS SDK's
 * `waitForInitialization()`. Omitting it makes the SDK log
 * "The waitForInitialization function was called without a timeout specified"
 * on every mount, and a future SDK version will pick the default for us.
 *
 * On timeout the provider keeps rendering children with fallback flag values and
 * subscribes to `ready`/`failed`, so flags still arrive once evalx responds —
 * the app just stops blocking on a slow LD edge. The SDK warns above 5 seconds,
 * so stay at or below that.
 */
export const LD_INIT_TIMEOUT_SECONDS = 5;
